import React, { memo } from 'react'
import { navigate } from 'gatsby'

import { QUERY_KEY_Q } from '../../slices/RecentArticlesSection'

import { Search } from '../../images/svg/search'

const WithInputSearch = ({ children, type, value }) => {
  const submitSearch = (e) => {
    e.preventDefault()
    navigate(`/${type}/search/?${QUERY_KEY_Q}=${value}`)
  }
  return (
    <form className="with-input-search" onSubmit={submitSearch}>
      <Search />
      {children}
    </form>
  )
}

export default memo(WithInputSearch)
